import React, { useCallback } from "react";

export function useMultistepForm(steps: React.JSX.Element[]) {
  const [currentIndex, setCurrentIndex] = React.useState<number>(0);

  const currentStep = steps[currentIndex];
  const firstStep = currentIndex === 0;
  const lastStep = currentIndex === steps.length - 1;

  const nextStep = () => {
    if (currentIndex >= steps.length - 1) return currentIndex;
    setCurrentIndex((index) => {
      return index + 1;
    });
  };

  const backStep = () => {
    if (currentIndex <= 0) return currentIndex;
    setCurrentIndex((index) => {
      return index - 1;
    });
  };

  const goToStep = useCallback((step: number) => {
    setCurrentIndex(step - 1);
  }, []);

  return {
    currentIndex,
    currentStepNumber: currentIndex + 1,
    currentStep,
    firstStep,
    lastStep,
    nextStep,
    backStep,
    goToStep,
  };
}
